"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatePolicyDocketDto = exports.UpdatePolicyDocketDocumentDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const create_policy_docket_dto_1 = require("./create-policy-docket.dto");
class UpdatePolicyDocketDocumentDto {
}
exports.UpdatePolicyDocketDocumentDto = UpdatePolicyDocketDocumentDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document Type ID",
        example: 237,
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], UpdatePolicyDocketDocumentDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document Type ID",
        example: 237,
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], UpdatePolicyDocketDocumentDto.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document ID",
        example: 25,
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], UpdatePolicyDocketDocumentDto.prototype, "documentId", void 0);
class UpdatePolicyDocketDto {
}
exports.UpdatePolicyDocketDto = UpdatePolicyDocketDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 789,
        description: "Opportunity Activity ID",
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], UpdatePolicyDocketDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 1,
        description: "Status ID",
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], UpdatePolicyDocketDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => create_policy_docket_dto_1.PlacementSlipDetailsDto),
    tslib_1.__metadata("design:type", typeof (_a = typeof create_policy_docket_dto_1.PlacementSlipDetailsDto !== "undefined" && create_policy_docket_dto_1.PlacementSlipDetailsDto) === "function" ? _a : Object)
], UpdatePolicyDocketDto.prototype, "placementSlipDetailsSection", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => create_policy_docket_dto_1.ServiceLevelAgreementDto),
    tslib_1.__metadata("design:type", typeof (_b = typeof create_policy_docket_dto_1.ServiceLevelAgreementDto !== "undefined" && create_policy_docket_dto_1.ServiceLevelAgreementDto) === "function" ? _b : Object)
], UpdatePolicyDocketDto.prototype, "serviceLevelAgreementSection", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: [UpdatePolicyDocketDocumentDto],
        description: "Array of documents",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ message: "Documents must be an array." }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => UpdatePolicyDocketDocumentDto),
    tslib_1.__metadata("design:type", Array)
], UpdatePolicyDocketDto.prototype, "documents", void 0);
